import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as Menu from '../../../components/menu'
import * as Router from '../../../router'
import * as Actions from './actions'

type OnEnter = ReduxObservable.Epic<Redux.Action, any>
const onEnter: OnEnter = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname === Menu.REPORTS_KNOWLEDGETIERS_URL)
    .map(store.getState)
    .map((state) => Actions.fetchKnowledgeTiers(state.app.selectedCommunity))

export const epic = ReduxObservable.combineEpics(onEnter)



// WEBPACK FOOTER //
// ./src/pages/reports/knowledge-tiers/epic.ts